export default __webpack_public_path__ + "static/media/APPLE_MAPS.8b59c445.png";